import { contexts } from 'constants/context';

const contextsThatHideHeader = [contexts.login, contexts.authentication];
const contextsThatHideSidebar = [contexts.login, contexts.authentication];

const hideElements = {
  contextsThatHideHeader,
  contextsThatHideSidebar,
};

export default hideElements;
